interface BrowserAuthConfig {
  memberExternalLoginPath?: string;
  memberExternalLoginProvider?: string;
}

declare global {
  interface Window {
    digitalAgoraAuth?: BrowserAuthConfig;
  }
}

const defaultExternalLoginPath = '/umbraco/surface/MemberExternalAuth/ExternalLogin';
const legacyExternalLoginProvider = 'UmbracoMembers._kctestmember';

export function getMemberExternalLoginUrl(returnTo?: string) {
  const rt = returnTo ?? window.location.pathname + window.location.search;
  const loginPath =
    window.digitalAgoraAuth?.memberExternalLoginPath?.trim() || defaultExternalLoginPath;
  const provider =
    window.digitalAgoraAuth?.memberExternalLoginProvider?.trim() || legacyExternalLoginProvider;

  return (
    loginPath + '?provider=' + encodeURIComponent(provider) + '&returnUrl=' + encodeURIComponent(rt)
  );
}
